<template>
    <div style="width: 100%; height: 100%; display: flex;">
        <svg width="100%" height="100%" viewBox="0 0 17 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <circle v-if="value" id="Oval" fill="#24ADBB" fill-rule="nonzero" cx="8.48071979" cy="8.39203085" r="8.03341902"></circle>
                <circle v-else id="Oval" fill="#BFBFBF" fill-rule="nonzero" cx="8.48071979" cy="8.39203085" r="8.03341902"></circle>
                <polygon v-if="value" id="Path" fill="#FFFFFF" fill-rule="nonzero" points="12.9794344 7.82326478 7.40102828 13.401671 4.3033419 10.3039846 4.3033419 6.58611825 7.40102828 9.67416452 12.9794344 4.10539846"></polygon>
            </g>
        </svg>
    </div>
</template>

<script>
    export default {
        name: "Checkbox",
        props: ['value']
    }
</script>

<style scoped>

</style>
